export const PERMISSIONS = [
  'media.view',
  'media.upload',
  'media.delete',
  'slideshows.view',
  'slideshows.create',
  'slideshows.edit',
  'slideshows.approve',
  'slideshows.publish',
  'channels.manage',
  'content_slots.populate',
  'content_slots.approve',
  'campaigns.manage',
  'data_sources.manage',
  'variables.view',
  'variables.manage',
  'variables.override',
  'schedules.manage',
  'emergency.broadcast',
  'displays.view',
  'displays.manage',
  'locations.manage',
  'players.manage',
  'players.remote_control',
  'users.manage',
  'roles.manage',
  'billing.manage',
  'settings.manage',
  'webhooks.manage',
  'analytics.view',
  'audit.view',
  'flows.view',
  'flows.manage',
] as const

export type Permission = (typeof PERMISSIONS)[number]

export type PermissionRequirement = Permission | readonly Permission[]
export type PermissionMode = 'any' | 'all'

/** Pure permission check. An empty requirement is always satisfied. */
export function hasPermission(
  granted: readonly string[] | null | undefined,
  required: PermissionRequirement | undefined,
  mode: PermissionMode = 'any',
): boolean {
  if (required === undefined) return true
  const list: readonly string[] = typeof required === 'string' ? [required] : required
  if (list.length === 0) return true
  if (!granted || granted.length === 0) return false
  const set = new Set(granted)
  return mode === 'all' ? list.every((p) => set.has(p)) : list.some((p) => set.has(p))
}
